<template>
    <div class="bg-white rounded shadow">
        <header class="flex items-center h-18 border-b px-4 sm:px-6">
            <h1 class="text-lg font-normal">
                Create a fee
            </h1>
        </header>

        <fees-store @success="onSuccess">
            <base-form
                slot-scope="{
                    sid,
                    is_loading: is_saving,
                    data: fee,
                    error,
                    forget,
                    store
                }"
                @submit="store(form)"
            >
                <div class="border-b px-4 pt-6 sm:px-6">
                    <validator-alert :sid="sid" />

                    <form-section>
                        <template slot="title">Basics</template>
                        <template slot="description">
                            How much do you want to charge?
                        </template>

                        <grid-layout>
                            <grid-layout-item class="md:w-1/2">
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="tenancy"
                                >
                                    <template slot="label">Tenancy</template>

                                    <input-tenancy
                                        v-model="form.tenancy"
                                        :uuid="$route.query.tenancy"
                                        :sid="sid"
                                        :disabled="is_saving"
                                        name="tenancy"
                                    />
                                </form-item>
                            </grid-layout-item>

                            <grid-layout-item class="md:w-1/2">
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="amount"
                                >
                                    <template slot="label">Amount</template>

                                    <div class="relative">
                                        <input-text
                                            v-model="form.amount"
                                            :sid="sid"
                                            :disabled="is_saving"
                                            type="tel"
                                            name="amount"
                                            class="pl-7"
                                        />
                                        <div class="absolute left-0 inset-y-0 margin-px pt-1 px-3 flex items-center text-grey-darker">
                                            &pound;
                                        </div>
                                    </div>
                                </form-item>
                            </grid-layout-item>

                            <grid-layout-item class="md:w-1/2">
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="due_at"
                                >
                                    <template slot="label">Due</template>

                                    <input-date
                                        v-model="form.due_at"
                                        :sid="sid"
                                        :disabled="is_saving"
                                        name="due_at"
                                    />
                                </form-item>
                            </grid-layout-item>
                        </grid-layout>
                    </form-section>
                </div>

                <div class="border-b px-4 pt-6 sm:px-6">
                    <form-section>
                        <template slot="title">Reason</template>
                        <template slot="description">
                            What are you creating this fee for?
                        </template>

                        <grid-layout>
                            <grid-layout-item>
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="title"
                                >
                                    <template slot="label">Title</template>

                                    <template slot="hint">
                                        Keep it short and to the point.
                                    </template>

                                    <input-text
                                        v-model="form.title"
                                        :sid="sid"
                                        :disabled="is_saving"
                                        name="title"
                                        placeholder="e.g. Late fee for November rent"
                                    />
                                </form-item>
                            </grid-layout-item>

                            <grid-layout-item>
                                <form-item
                                    :sid="sid"
                                    :is-required="false"
                                    name="description"
                                >
                                    <template slot="label">Notes</template>

                                    <input-textarea
                                        v-model="form.description"
                                        :sid="sid"
                                        :disabled="is_saving"
                                        name="description"
                                        placeholder="e.g. As per the contract, this is a fee of 5% for the late payment of Novembers rent"
                                    />
                                </form-item>
                            </grid-layout-item>
                        </grid-layout>
                    </form-section>
                </div>

                <div class="bg-grey-bg text-right px-4 py-3 sm:px-6">
                    <base-button
                        :is-loading="is_saving"
                        class="btn-blue w-full md:w-auto"
                    >
                        Create Fee
                    </base-button>
                </div>

                <error-modal
                    v-if="error && $error.is(error, { exclude: [422] })"
                    :error="error"
                />

                <modal-success
                    :is-open="show_created_modal"
                    @close="show_created_modal = false; forget(); reset()"
                >
                    <template slot="heading">Fee created!</template>

                    <p>
                        Your fee has been created. We have notified your tenants
                        that you've added this fee.
                    </p>

                    <div
                        slot="footer"
                        slot-scope="{ close }"
                        class="flex flex-col md:flex-row-reverse"
                    >
                        <router-link
                            :to="{
                                name: $router.fix('dashboard.*.fees.show'),
                                params: {
                                    fee: fee.uuid
                                }
                            }"
                            class="btn btn-green text-center"
                        >
                            Go to Fee
                        </router-link>

                        <button
                            type="button"
                            @click.prevent="close"
                            class="btn mt-3 md:mt-0 md:mr-3 text-center"
                        >
                            Add another
                        </button>
                    </div>
                </modal-success>
            </base-form>
        </fees-store>
    </div>
</template>

<script>
    import FeesStore from '../../../../components/fees-store'
    import InputTenancy from '../../../../components/input-tenancy'

    export default {
        components: {
            FeesStore,
            InputTenancy
        },
        data () {
            return {
                show_created_modal: false,
                form: {
                    tenancy: null,
                    currency: 'gbp',
                    amount: '',
                    due_at: '',
                    title: '',
                    description: ''
                }
            }
        },
        methods: {
            onSuccess () {
                setTimeout(() => {
                    this.show_created_modal = true
                }, 0)
            },
            reset () {
                this.$validator.reset(this.sid)

                Object.assign(this.$data, this.$options.data.apply(this))
            }
        }
    }
</script>
